// FCM Configuration for Web App
export const FCM_CONFIG = {
  // FCM API endpoint
  FCM_API_ENDPOINT: 'https://fcm.googleapis.com/fcm/send',
  
  // FCM Server Key (from Firebase Console > Project Settings > Cloud Messaging)
  // This is required to send FCM notifications from the server
  SERVER_KEY: process.env.REACT_APP_FCM_SERVER_KEY || 'YOUR_FCM_SERVER_KEY_HERE',
  
  // Firebase Project Sender ID (from Firebase Console > Project Settings > General)
  SENDER_ID: process.env.REACT_APP_FIREBASE_SENDER_ID || 'convive-a5305',
  
  // Default notification channel for Android
  DEFAULT_CHANNEL_ID: 'convive_default',
  DEFAULT_CHANNEL_NAME: 'ConVive Notifications',
  DEFAULT_CHANNEL_DESCRIPTION: 'Default notification channel for ConVive app',
};

// FCM Permission States
export const FCM_PERMISSION_STATES = {
  GRANTED: 'granted',
  DENIED: 'denied',
  DEFAULT: 'default',
} as const;

export type FCMPermissionState = typeof FCM_PERMISSION_STATES[keyof typeof FCM_PERMISSION_STATES];

// FCM Token storage key
export const FCM_TOKEN_STORAGE_KEY = 'fcm_token';

// FCM Message types
export const FCM_MESSAGE_TYPES = {
  CHAT_MESSAGE: 'chat_message',
  NOTIFICATION: 'notification',
  ALERT: 'alert',
} as const;

// FCM Configuration validation
export const validateFCMConfig = (): boolean => {
  if (!FCM_CONFIG.SERVER_KEY || FCM_CONFIG.SERVER_KEY === 'YOUR_FCM_SERVER_KEY_HERE') {
    console.error('FCM Server Key not configured. Please set REACT_APP_FCM_SERVER_KEY environment variable.');
    return false;
  }
  
  return true;
};

// FCM Feature detection
export const checkFCMSupport = async (): Promise<{
  isSupported: boolean;
  hasServiceWorker: boolean;
  hasNotifications: boolean;
  hasPushManager: boolean;
}> => {
  const support = {
    isSupported: false,
    hasServiceWorker: 'serviceWorker' in navigator,
    hasNotifications: 'Notification' in window,
    hasPushManager: 'PushManager' in window,
  };
  
  support.isSupported = support.hasServiceWorker && support.hasNotifications && support.hasPushManager;
  
  return support;
};

// FCM Debug logging
export const enableFCMDebug = (): void => {
  // Debug logging disabled to reduce console clutter
};
